import Routes from '@lib/routes'
import deleteFacetFilterFromSlug from '../facetFilters/deleteFacetFilterFromSlug'

export default function stripTreatmentAndPaidFromSlug({
  pathname,
}: {
  pathname: string | null
}) {
  if (!pathname) {
    return Routes.search
  }

  const withoutPaid = deleteFacetFilterFromSlug({
    facet: 'paid',
    slug: pathname,
  })

  const withoutTreatment = deleteFacetFilterFromSlug({
    facet: 'treatment',
    slug: withoutPaid ?? pathname,
  })

  return withoutTreatment ?? Routes.search
}
